import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { createTimeOfDayModel, TimeOfDayModel } from "./TimeOfDayModel";
import {
  createDatePickerModel,
  DatePickerModel,
} from "../../models/DatePickerModel";
import { ScheduleType } from "@pulse/pulse-rpcs/lib/email-cycle/scheduleType";
import { createDaysOfWeekModel, DaysOfWeekModel } from "./DaysOfWeekModel";

export const RecurringScheduleModel = types
  .model("RecurringScheduleModel", {
    type: types.literal("RECURRING_SCHEDULE"),
    startDate: DatePickerModel,
    endDate: DatePickerModel,
    daysOfWeek: DaysOfWeekModel,
    timeOfDay: TimeOfDayModel,
  })
  .views((store) => ({
    get isEmptyValues(): boolean {
      return (
        !store.startDate.date ||
        !store.endDate.date ||
        !store.daysOfWeek.value.length
      );
    },

    get hasValidateError(): boolean {
      return !!(
        store.startDate.validationError ?? store.endDate.validationError
      );
    },

    get rpcObject(): ScheduleType.Recurring {
      return new ScheduleType.Recurring(
        store.startDate.rpcObject,
        store.endDate.rpcObject,
        store.daysOfWeek.value,
        store.timeOfDay.rpcObject,
      );
    },
  }));

export const createRecurringScheduleModel = (
  recurringScheduleModel?: SnapshotIn<typeof RecurringScheduleModel>,
): Instance<typeof RecurringScheduleModel> =>
  RecurringScheduleModel.create(
    recurringScheduleModel ?? {
      type: "RECURRING_SCHEDULE",
      startDate: createDatePickerModel(),
      endDate: createDatePickerModel({}),
      daysOfWeek: createDaysOfWeekModel(),
      timeOfDay: createTimeOfDayModel(),
    },
  );
